module.exports = __webpack_public_path__ + "static/img/ios_id.9ffd3ee9.png";